import { render, staticRenderFns } from "./ContentSearch.vue?vue&type=template&id=cd53f47c"
import script from "./ContentSearch.vue?vue&type=script&lang=js"
export * from "./ContentSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports